<div style="height: 85vh" id="splash-index">
  <div class="h-100 d-flex justify-content-center align-items-center">
    @if (!registered && !permissionsService.user) {
      <div class="index-container text-center">
        <p>Please enter the details of the head guest, we will email more information</p>
        <form [formGroup]="form">
          <text-input
            [styles]="{ 'max-width': '65%', width: '500px' }"
            placeHolder="Name"
            type="text"
            [form]="form"
            formControlName="name"
            [error]="formErrors.name"
          ></text-input>
          <br />
          <text-input
            [styles]="{ 'max-width': '65%', width: '500px' }"
            placeHolder="Email"
            type="email"
            [form]="form"
            formControlName="email"
            [error]="formErrors.email"
          ></text-input>
          <br />
          <raised-button
            [styles]="{ 'max-width': '65%', width: '500px', marginTop: '20px' }"
            [disabled]="submitting"
            (click)="register()"
            color="primary"
            >
            Register Email
          </raised-button>
        </form>
      </div>
    }
    @if (registered && !permissionsService.user) {
      <div class="index-container text-center">
        <p>{{ successMessage }}</p>
      </div>
    }
    @if (permissionsService.user) {
      <div class="index-container text-center">
        <h1>Welcome back, {{ permissionsService.user.name }}!</h1>
        <flat-button color="primary" (click)="goToAccount()">Go to My Account</flat-button>
      </div>
    }
  </div>
</div>
